import { Box, Container, Stack, Typography } from '@mui/material'
import React from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetStatusState } from '../../slices/statusSlice'
import { customStyles } from '../../styles'
import { animations } from '../../utils/animations'
import { useTimerAlert } from '../../hooks/useTimerAlert'
import { CustomAlert } from '../helpers/alert/CustomAlert'
import { NextBackButtons } from '../helpers/buttons/NextBackButtons'
import { Title } from '../helpers'




export const BodyContainer = (props) => {
   const { children, title, sx } = props
   const { colors: { main }, containers: { large } } = customStyles
   const dispatch = useDispatch()
   const { message, alert } = useSelector(state => state.status)

   const { handleTimer, timer } = useTimerAlert(alert)

   // useEffect(() => {
   //    handleTimer()
   //    return () => {
   //       clearTimeout(timer)
   //    }
   // }, [])
  return (
    <Stack  alignItems="center" width="100%" 
      eight="70vh" className={ animations.fadeIn } sx={{justifyContent:"center", ...sx}}>
        {
          alert && <CustomAlert transition={alert}/>     
        }
      {/* <Stack sx={ box } justifyContent="space-evenly"> */}
         <Stack justifyContent="center" alignItems="center"  height="inherit" maxWidth={large} >
      <Title text={title} sx={{marginBottom: 5}} color={customStyles.colors.main}/>
            { children }
         </Stack>
         {/* <NextBackButtons /> */}
      {/* </Stack> */}
    </Stack>
  )
}
